<!-- @format -->

<ng-container *transloco="let t">
  <main class="logout-page" role="main">
    <fudis-heading [level]="1" [align]="'center'">{{ t("LOGOUT_PAGE.TITLE") }}</fudis-heading>
    @if (universityName$ | async; as universityName) {
      <fudis-body-text [variant]="'lg-regular'" [align]="'center'">{{ universityName }}</fudis-body-text>
    }

    <fudis-body-text class="logout-page__message" [align]="'center'">{{ t("LOGOUT_PAGE.MESSAGE") }}</fudis-body-text>

    <fudis-hr />

    <fudis-body-text class="logout-page__relogin-question" [align]="'center'">{{ t("LOGOUT_PAGE.RELOGIN_QUESTION") }}</fudis-body-text>

    <fudis-button [label]="t('LOGOUT_PAGE.LOGIN_BUTTON')" [variant]="'secondary'" (handleClick)="navigateToLogin()" />
  </main>
</ng-container>
